const PRODUCTION = 'production-profile';
const PERFORMANCE = 'performance';
const ESTIMATED = 'estimated-production';
const WEATHER = 'weather';
const METER = 'meter';
const VIEWS = [PRODUCTION, PERFORMANCE, ESTIMATED, WEATHER, METER];

export { PRODUCTION, PERFORMANCE, ESTIMATED, WEATHER, METER };
export default VIEWS;
